import { Minus, Plus, RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "~/components/ui";

interface TimelineZoomControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onZoomReset: () => void;
}

export function TimelineZoomControls({ onZoomIn, onZoomOut, onZoomReset }: TimelineZoomControlsProps) {
  const { t } = useTranslation();

  return (
    <div className="absolute bottom-3 right-3 flex flex-col gap-1">
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="h-8 w-8 bg-white/95 shadow-sm"
        onClick={onZoomIn}
        aria-label={t("ui.zoomIn")}
      >
        <Plus />
      </Button>
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="h-8 w-8 bg-white/95 shadow-sm"
        onClick={onZoomOut}
        aria-label={t("ui.zoomOut")}
      >
        <Minus />
      </Button>
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="h-8 w-8 bg-white/95 shadow-sm"
        onClick={onZoomReset}
        aria-label={t("ui.resetZoom")}
      >
        <RotateCcw />
      </Button>
    </div>
  );
}
